import { NgModule } from '@angular/core';
import { Four04PageComponent } from 'src/app/pages/components/four04-page/four04-page.component';
import { HomePageComponent } from 'src/app/pages/components/home-page/home-page.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { UnauthorizedPageComponent } from './components/unauthorized-page/unauthorized-page.component';

@NgModule({
  imports: [SharedModule],
  declarations: [HomePageComponent, Four04PageComponent, UnauthorizedPageComponent],
})
export class PagesModule {}
